<template>
  <div>
    <div v-if="courseHierarchyLoading" class="progress-wheel">
      <v-progress-circular  id="course-hierarchy-spinner" indeterminate :size="50" color="accent"></v-progress-circular>
    </div>
    <div v-else v-for="(type, keyType) in filterTypes" class="pb-2">
      <h4>{{$t(type.header)}}</h4>
      <v-layout v-if="type.isList" row wrap>
        <filter-list :filter-type="keyType" @filter:list-change="filterListChangeInner"
                     :source="listSources[type.listName]" :element-id="translatedElementId(type.header)" :filter-name="type.listName"></filter-list>
      </v-layout>
      <v-layout v-else row wrap>
        <filter-button v-for="(button, keyName) in type.values" :key="keyName" :text="button.text"
                       :filter-type="keyType" :filter-name="keyName"
                       :enabled="button.value"
                       @filter:button-change="filterButtonChangeInner"
                       :icon="button.icon" :element-id="elementId(button.text)"/>
      </v-layout>
    </div>
  </div>
</template>

<script>
  import FilterButton from './AlertFilterButton'
  import FilterList from './AlertFilterList'
  import { mapMutations, mapState } from 'vuex'
  import {
    SET_ALERT_ACADEMIC_YEAR, SET_ALERT_COURSE_LEVEL,
    SET_ALERT_ENROLMENT_STATUS,
    SET_STUDY_MODE_FOR_ALERT_FROM_CHANGE, SET_COURSES_FOR_ALERTS_FROM_CHANGE,
    SET_CUSTOM_ALERT_FILTERS
  } from '../../../store/mutation-types'

  export default {
    components: {FilterButton, FilterList},
    name: 'alert-filter-component',
    props: {
      updateAlert: {
        type: Function,
        required: true
      },
      filterTypes: {
        type: Object,
        required: true
      },
      filterChange: {
        type: Function,
        required: true
      },
      filterListChange: {
        type: Function
      },
      listSources: {
        type: Object
      },
      alert: {
        type: Object,
        required: true
      }
    },
    methods: {
      filterButtonChangeInner (filterObject) {
        this.filterChange(filterObject) // Toggle Button
        // catch custom filters
        try {
          this[filterObject.filterType]() // Set localToServer
        } catch (e) {
          this.customFilters(filterObject.filterType) // Set localToServer
        }
        this.updateAlert({alert: this.$store.state.admin.newSingleAlert})
      },
      filterListChangeInner  (filterObject) {
        this.filterListChange(filterObject) // Toggle Button
        // catch custom filters
        try {
          this[filterObject.filterType]() // Set localToServer
        } catch (e) {
          this.customFilters(filterObject.filterType) // Set localToServer
        }
        this.updateAlert({alert: this.$store.state.admin.newSingleAlert})
      },
      ...mapMutations({
        courseIds: SET_COURSES_FOR_ALERTS_FROM_CHANGE,
        studyModes: SET_STUDY_MODE_FOR_ALERT_FROM_CHANGE,
        courseYears: SET_ALERT_ACADEMIC_YEAR,
        enrolmentStatus: SET_ALERT_ENROLMENT_STATUS,
        courseLevels: SET_ALERT_COURSE_LEVEL,
        customFilters: SET_CUSTOM_ALERT_FILTERS
      }),
      elementId (val) {
        return `alert-filter-${val.replace(' ', '-').toLowerCase()}`
      },
      translatedElementId (val) {
        return this.elementId(this.$t(val))
      }
    },
    computed: {
      ...mapState({
        courseHierarchyLoading: state => state.admin.courseHierarchyLoading
      })
    }
  }
</script>

<style scoped>
  .progress-wheel {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertFilterComponent.vue